"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraPopconfirm = void 0;
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
require("../styles/eura-popconfirm.css");
/**
 * Wrapattu AntD:n Popconfirm-komponentti.
 * Propsikuvaus: https://ant.design/components/popconfirm/#API
 * @param props
 *
 * eura popconfirm menee piiloon aina jos fokus siirtyy elementin ulkopuolelle tai klikataan elementin ulkopuolista komponenttia
 */
const EuraPopconfirm = (props) => {
    var _a;
    const classConstruct = ['eura-popconfirm', props.infoDialog ? 'info-dialog' : '', (_a = props.overlayClassName) !== null && _a !== void 0 ? _a : ''];
    const previousFocus = (0, react_1.useRef)(null);
    const previousVisible = (0, react_1.useRef)(false);
    const dialogID = (0, react_1.useRef)(`popconfirm-${Math.random().toString(32).substr(0, 15)}`);
    /**
     * AntD visibleChange ei ole aivan luotettava, joten tehdään IntersectionObserver lisätarkastelu komponentin näkyvyydelle
     */
    const observer = new IntersectionObserver((intersections) => intersections.filter((intersection) => !intersection.isIntersecting).forEach((intersection) => visibleChange(false)), { threshold: 0.5 });
    /**
     * keyPress tulee käyttää useCallbackia, tai removeEventListener ei toimi
     *
     * Näppäinoikoteiden toiminta riippuu siitä, onko focus popconfirmin sisällä vai ei
     * mikäli onCancel puuttuu, piilotus tulee tehdä ohjelmallisesti painamalla cancel-paniketta
     * estetään ENTER-hyväksyntä, mikäli focus on jo popupin sisällä
     */
    const keyPress = (0, react_1.useCallback)((keyEvent) => {
        var _a, _b, _c;
        const [escKey, enterKey, tabKey] = ['Escape', 'Enter', 'Tab'];
        if (keyEvent.code === escKey) {
            if (props.onCancel) {
                props.onCancel();
            }
            else {
                const cancelButton = (_a = document.getElementById(dialogID.current)) === null || _a === void 0 ? void 0 : _a.querySelector('.ant-popover-buttons > .ant-btn');
                if (cancelButton) {
                    window.removeEventListener('click', onClick, false);
                    setTimeout(() => cancelButton === null || cancelButton === void 0 ? void 0 : cancelButton.click(), 0);
                }
            }
        }
        else if (keyEvent.code === enterKey) {
            const focusWithinPopconfirm = (_b = document.getElementById(dialogID.current)) === null || _b === void 0 ? void 0 : _b.querySelector('.ant-popover-buttons:focus-within');
            if (props.onConfirm && !focusWithinPopconfirm) {
                props.onConfirm();
            }
        }
        else if (keyEvent.code === tabKey) {
            // suljetaan popup mikäli täbätään OK-painikkeen päällä, muuten focus saattaa hypätä ulos sivulta selaimen navigointiin
            const focusWithinPopconfirm = (_c = document
                .getElementById(dialogID.current)) === null || _c === void 0 ? void 0 : _c.querySelector('.ant-popover-buttons > .ant-btn-primary:focus-within');
            if (focusWithinPopconfirm) {
                keyEvent.preventDefault();
                pressEscape();
            }
        }
    }, []);
    const focusOut = (0, react_1.useCallback)((ev) => {
        if (!isTargetPopconfirm(ev.relatedTarget)) {
            pressEscape();
        }
    }, []);
    const onClick = (0, react_1.useCallback)((ev) => {
        if (!isTargetPopconfirm(ev.target)) {
            ev.preventDefault();
            pressEscape();
        }
    }, []);
    /**
     * Päätellään focusattava painike sen perusteella onko cancelText määritelty
     * cancel button on ensimmäinen .ant-btn, mikäli näkyvissä. .ant-btn-primary on OK painike
     */
    const popupOpened = () => {
        const dialog = document.getElementById(dialogID.current);
        if (dialog) {
            observer.unobserve(dialog);
            observer.observe(dialog);
        }
        previousFocus.current = previousFocus.current || document.activeElement;
        const targetClass = props.cancelText ? 'ant-btn' : 'ant-btn-primary';
        const targetButton = dialog === null || dialog === void 0 ? void 0 : dialog.querySelector(`.ant-popover-buttons > .${targetClass}`);
        setTimeout(() => {
            targetButton === null || targetButton === void 0 ? void 0 : targetButton.focus();
            window.addEventListener('keydown', keyPress, false);
            window.addEventListener('click', onClick, false);
            window.addEventListener('focusout', focusOut, false);
        }, 100);
    };
    const popupClosed = () => {
        var _a;
        setTimeout(() => {
            window.removeEventListener('keydown', keyPress, false);
            window.removeEventListener('focusout', focusOut, false);
            window.removeEventListener('click', onClick, false);
            if (document.getElementById(dialogID.current)) {
                observer.unobserve(document.getElementById(dialogID.current));
            }
        }, 100);
        (_a = previousFocus.current) === null || _a === void 0 ? void 0 : _a.focus();
        previousFocus.current = null;
    };
    const visibleChange = (visible) => {
        if (visible !== previousVisible.current) {
            previousVisible.current = visible;
            if (previousVisible.current) {
                popupOpened();
            }
            else {
                popupClosed();
            }
        }
    };
    const pressEscape = () => {
        keyPress(new KeyboardEvent('keypress', { code: 'Escape' }));
    };
    const isTargetPopconfirm = (target) => {
        var _a;
        return !target || !!((_a = document.getElementById(dialogID.current)) === null || _a === void 0 ? void 0 : _a.contains(target));
    };
    return (react_1.default.createElement(antd_1.Popconfirm, Object.assign({ id: dialogID.current, defaultVisible: false, afterVisibleChange: (visible) => visibleChange(visible), icon: props.icon || react_1.default.createElement(react_1.default.Fragment, null), overlayClassName: classConstruct.join(' ') }, props, { title: typeof props.title === 'string' ? react_1.default.createElement("span", { role: 'alert' }, props.title) : props.title }), props.children));
};
exports.EuraPopconfirm = EuraPopconfirm;
